import history from "@ane/core/lib/CreateHistory";
import { combineEpics } from "redux-observable";
import dataSourceDetailEpic from "./DataSourceDetailEpic.js";
import dataSourceOverrideDetailEpic from "./DataSourceOverrideDetailEpic.js";
import DataSourceAccessEpic from "./DataSourceAccessEpic.js";
import { provideDataSourceSchemaEpics } from "./DataSourceSchemaEpic.js";
import DataSourceHistoryEpic from "./DataSourceHistoryEpic.js";
import DataSourceStatusEpic from "./DataSourceStatusEpic.js";
import DataSourceDetailOverrideListEpic from "./DataSourceDetailOverrideListEpic.js";
import DataSourceFlightFormatsEpic from "../../DataSourceCreate/epics/DataSourceFlightFormatsEpic.js";
import DataSourceProfilingEpic from "./DataSourceProfilingEpic.js";
import DataSourceValidateTriggerEpic from "./DataSourceValidateTriggerEpic.js";
const dataSourceSchemaEpic = provideDataSourceSchemaEpics(history);
const rootEpic = combineEpics(
  dataSourceDetailEpic,
  dataSourceOverrideDetailEpic,
  DataSourceAccessEpic,
  dataSourceSchemaEpic,
  DataSourceHistoryEpic,
  DataSourceDetailOverrideListEpic,
  DataSourceStatusEpic,
  DataSourceFlightFormatsEpic,
  DataSourceProfilingEpic,
  DataSourceValidateTriggerEpic
);
export {
  rootEpic as default,
  rootEpic
};
//# sourceMappingURL=epics.js.map
